/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService
 */

export const EmailSendInternalChirpErrorTypename = 'com.hubspot.commerce.tool.sender.models.email.validation.errors.EmailSendInternalChirpError';
export const EmailSendValidationChirpErrorTypename = 'com.hubspot.commerce.tool.sender.models.email.validation.errors.EmailSendValidationChirpError';
export const MissingPortalIdChirpErrorTypename = 'com.hubspot.commerce.tool.sender.models.email.validation.errors.MissingPortalIdChirpError';
export const MissingUserIdChirpErrorTypename = 'com.hubspot.commerce.tool.sender.models.email.validation.errors.MissingUserIdChirpError';
export const MultipleEmailSendValidationChirpErrorsTypename = 'com.hubspot.commerce.tool.sender.models.email.validation.errors.MultipleEmailSendValidationChirpErrors';
export const RequiredPropertyMissingRetryableChirpErrorTypename = 'com.hubspot.commerce.tool.sender.models.email.validation.errors.RequiredPropertyMissingRetryableChirpError';
export let ComHubspotCommerceToolSenderModelsEmailValidationErrors;
(function (_ComHubspotCommerceToolSenderModelsEmailValidationErrors) {})(ComHubspotCommerceToolSenderModelsEmailValidationErrors || (ComHubspotCommerceToolSenderModelsEmailValidationErrors = {}));
export const EmailAddressValidationChirpErrorTypename = 'com.hubspot.commerce.tool.sender.models.email.validation.errors.emailaddress.EmailAddressValidationChirpError';
export let ComHubspotCommerceToolSenderModelsEmailValidationErrorsEmailaddress;
(function (_ComHubspotCommerceToolSenderModelsEmailValidationErrorsEmailaddress) {})(ComHubspotCommerceToolSenderModelsEmailValidationErrorsEmailaddress || (ComHubspotCommerceToolSenderModelsEmailValidationErrorsEmailaddress = {}));
export const getEmailSendPreviewRpc = {
  serviceName: 'com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService',
  rpcName: 'getEmailSendPreview',
  auth: 'app',
  fingerprint: 'lqa8nShvUUYEAksi71Y286V_dzK6E15R',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEmailSendPreviewQuoteContextRpc = {
  serviceName: 'com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService',
  rpcName: 'getEmailSendPreviewQuoteContext',
  auth: 'app',
  fingerprint: 'CXWw-YUknu5UpXBsJc319KV_dzK6E15R',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEmailContextForDebugRpc = {
  serviceName: 'com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService',
  rpcName: 'getEmailContextForDebug',
  auth: 'app',
  fingerprint: 'B3Fbmm5QfWPUHbmgnIkxH6V_dzK6E15R',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendEmailRpc = {
  serviceName: 'com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService',
  rpcName: 'sendEmail',
  auth: 'app',
  fingerprint: 'vLThI8CLRUCl5kZV7CU5mqV_dzK6E15R',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};